// reports.utils.js

import { Chip } from '@mui/material'

export function normalizeId(v) {
    if (!v) return ''
    if (typeof v === 'string') return v
    if (v._id) return v._id
    return ''
}

export function toDateInput(d) {
    if (!d) return ''
    const date = new Date(d)
    if (Number.isNaN(date.getTime())) return ''
    return date.toISOString().slice(0, 10)
}

export function formatDate(d) {
    if (!d) return ''
    const date = new Date(d)
    if (Number.isNaN(date.getTime())) return ''
    return date.toISOString().slice(0, 10)
}

export function formatMoney(v) {
    if (v == null || v === '') return ''
    const n = Number(v)
    if (!Number.isFinite(n)) return ''
    return n.toFixed(2)
}

export function formatReportTypes(types, xbrlService) {
    const arr = Array.isArray(types) ? types : []
    const base = arr.length ? arr.join(', ') : ''
    if (xbrlService) return base ? `${base}, XBRL` : 'XBRL'
    return base
}

export function renderReportTypeChips(types, xbrlService) {
    const arr = Array.isArray(types) ? types : []
    const out = [...arr]
    if (xbrlService) out.push('XBRL')

    if (!out.length) {
        return <Chip size='small' label='-' variant='outlined' />
    }

    return out.map((t, idx) => (
        <Chip
            key={`${t}-${idx}`}
            size='small'
            label={t}
            variant='outlined'
        />
    ))
}

export function normalizeRows(reportCases) {
    if (!reportCases) return []

    if (Array.isArray(reportCases.items)) return reportCases.items

    if (Array.isArray(reportCases)) return reportCases
    if (Array.isArray(reportCases.data)) return reportCases.data
    if (Array.isArray(reportCases.reportCases)) return reportCases.reportCases

    if (typeof reportCases === 'object') return Object.values(reportCases)

    return []
}

export function withStableIds(rows) {
    const arr = Array.isArray(rows) ? rows : []

    return arr.map((r, idx) => {
        if (!r) return { _id: `tmp-${idx}` }

        // Mongo usually uses _id; some APIs return id
        const id = r._id || r.id || `tmp-${idx}`

        return {
            ...r,
            _id: id
        }
    })
}